// extracted by mini-css-extract-plugin
export default {"shop":"Shop_shop__SuqRb","card_title":"Shop_card_title__D+PxY"};